import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Redirect, Route, Switch } from 'react-router-dom';

import { Skeleton } from 'antd';
import { gtmError } from './util/gtm';

import { Helmet } from "react-helmet";

import config from './config';

// Layouts
import EntryPage from './layouts/EntryPage';
import DashboardPage from './layouts/DashboardPage';

import * as actions from './actions';

class App extends Component {
  componentDidMount() {
    document.title = `Provider Dashboard`;
    this.checkViewPort();
  }

  checkViewPort() {
    const { dispatch } = this.props;
    const desktopBreakPoint = window.matchMedia('(min-width: 62rem)');
    const printBreakPoint = window.matchMedia('print');

    dispatch(actions.appActions.checkViewPort(desktopBreakPoint));

    // Event Listeners
    !printBreakPoint.matches &&
      desktopBreakPoint.addListener(mq =>
        dispatch(actions.appActions.checkViewPort(mq))
      );
  }

  render() {
    const {
      providers,
      providersLoading,
      providersError,
      providerDetails,
      currentProviderContent,
      location
    } = this.props;
    const dashboard = providers.map(
      provider =>
        `${config.APP_PATH}/${provider.slug}/:providerSection?/:subSection?`
    );
    providersError && gtmError();

    // Helmet metadata - START

      const removeEverythingAfter = window.location.href.indexOf('/_' || '/?' || '?');
      const thePathToFindLength = window.location.href.match(/\/type\//g) ? window.location.href.substring(0, removeEverythingAfter !== -1 ? removeEverythingAfter : window.location.href.length).split("type").pop().match(/\//g).length : null;
      const theLastPath = window.location.href.substring(0, removeEverythingAfter !== -1 ? removeEverythingAfter : window.location.href.length).substring(window.location.href.substring(0, removeEverythingAfter !== -1 ? removeEverythingAfter : window.location.href.length).lastIndexOf("/") + 1, window.location.href.length);

      const subSectionFound = currentProviderContent.subSections.filter(item => item.slug === theLastPath);

      const thePathToFollow = thePathToFindLength === 3 && subSectionFound[0] ? subSectionFound[0].metadata
                            : thePathToFindLength === 2 && currentProviderContent.metadata[0] ? currentProviderContent.metadata
                            : providerDetails.metadata ? providerDetails.metadata
                            : null;

      const HelmetComponent = () => (
        <Helmet>
          <meta charSet="utf-8" />
          { (thePathToFollow !== undefined && thePathToFollow !== null) && thePathToFollow.map(metadata => {
            return  <meta
                      key={metadata.name.charAt(0).toUpperCase() +  metadata.name.slice(1).replace('cterms', 'CTERMS.')}
                      name={metadata.name.charAt(0).toUpperCase() +  metadata.name.slice(1).replace('cterms', 'CTERMS.')}
                      content={metadata.value}
                    />
          })}
          <link rel="canonical" href={thePathToFindLength === 3 && subSectionFound[0] ? subSectionFound[0].url.replace('/index/', '/') : thePathToFindLength === 2 && currentProviderContent.url !== "" ? currentProviderContent.url.replace('/index/', '/') : providerDetails.url ? providerDetails.url.replace('/index/', '/') : null} />
        </Helmet>
      )

    // Helmet metadata - END

    return !providersError ? (
      <>
        <HelmetComponent />
        <Skeleton active loading={providersLoading}>
          <Switch>
            {/* Strip trailing slashes
             * https://github.com/ReactTraining/react-router/issues/4841#issuecomment-500706719
             */
            location.pathname !== '/' && /\/$/.test(location.pathname) && (
              <Redirect to={location.pathname.slice(0, -1)} />
            )}
            <Route exact path={dashboard} component={DashboardPage} />
            <Route component={EntryPage} />
          </Switch>
        </Skeleton>
      </>
    ) : (
      <div>There was a problem loading the Provider Dashboard.</div>
    );
  }
}

const mapStateToProps = state => ({
  providers: state.providers.data,
  providersLoading: state.providers.loading,
  providerDetails: state.providerDetails.data,
  currentProviderContent: state.currentProviderContent,
  providersError: state.providers.error
});

export default connect(mapStateToProps)(App);
